<template>
  <section>
    <el-popover v-if="isBtnShow" :trigger="trigger" :placement="placement" :title="title">
      <ext-text :content="displayContent"/>
      <el-button slot="reference" :size="btnSize">{{ btnLabel }}</el-button>
    </el-popover>
    <span v-else class="empty-text-display">{{ emptyDisplay }}</span>
  </section>
</template>

<script>
import ExtText from '@/components/ExtText/index.vue'

export default {
  name: 'ExtTextPopover',
  components: { ExtText },
  props: {
    value: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: [String, Array, Object],
      default: ''
    },
    trigger: {
      type: String,
      default: 'hover'
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    btnShow: {
      type: Boolean,
      default: true
    },
    btnLabel: {
      type: String,
      default: '查看'
    },
    btnSize: {
      type: String,
      default: 'mini'
    }
  },
  computed: {
    stringValue () {
      if (this.content === null || this.content === undefined) {
        return ''
      }
      if (typeof this.content === 'object') {
        try {
          return JSON.stringify(this.content)
        } catch (e) {
          return String(this.content)
        }
      }
      return String(this.content)
    },
    isBtnShow () {
      if (!this.value || this.content === null || this.content === undefined) {
        return false
      }
      const trimmed = this.stringValue.trim()
      if (trimmed === '' || trimmed === '""') {
        return false
      }
      return true
    },
    emptyDisplay () {
      const trimmed = this.stringValue.trim()
      if (trimmed === '""' || trimmed === '') return '-'
      return trimmed || '-'
    },
    displayContent () {
      if (typeof this.content === 'object' && this.content !== null) {
        try {
          return JSON.stringify(this.content, null, 2)
        } catch (e) {
          return this.stringValue
        }
      }
      const trimmed = String(this.content || '').trim()
      if ((trimmed.startsWith('[') && trimmed.endsWith(']')) || (trimmed.startsWith('{') && trimmed.endsWith('}'))) {
        try {
          return JSON.stringify(JSON.parse(trimmed), null, 2)
        } catch (e) {
          return trimmed
        }
      }
      return trimmed
    }
  }
}
</script>

<style scoped>

</style>
